The details of the webhook subscription signing configuration to be updated.
